/* Cart totals and eligibility are always rendered by Shopify Liquid. */
(() => {
  'use strict';
  let busy = false;
  const root = () => document.querySelector('[data-wk-cart]');
  const empty = value => value == null || Object.keys(value).length === 0;
  const plain = item => empty(item.properties) && item.selling_plan_allocation == null && empty(item.item_components) && empty(item.components) && item.parent_relationship == null;
  const stable = value => JSON.stringify(value, function (key, item) {
    return item && typeof item === 'object' && !Array.isArray(item) ? Object.fromEntries(Object.keys(item).sort().map(k => [k, item[k]])) : item;
  });
  const signature = items => stable(items.map(item => ({key: item.key, variant: String(item.variant_id), quantity: item.quantity, properties: empty(item.properties) ? null : item.properties, plan: item.selling_plan_allocation || null, components: empty(item.components) ? null : item.components, item_components: empty(item.item_components) ? null : item.item_components, parent: item.parent_relationship || null, original: item.original_line_price, final: item.final_line_price})).sort((a,b) => a.key.localeCompare(b.key)));
  const snapshot = node => JSON.parse(node.querySelector('[data-cart-snapshot]').textContent);
  async function readCart(url) {
    const response = await fetch(url + '.js', {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error('Cart read failed');
    const cart = await response.json();
    if (!Array.isArray(cart.items) || !Number.isInteger(cart.item_count)) throw new Error('Invalid cart response');
    return cart;
  }
  async function serverRoot(url, cart) {
    const response = await fetch(url + '?wk_cart_refresh=' + Date.now(), {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'text/html'}});
    if (!response.ok) throw new Error('Cart render failed');
    const node = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-wk-cart]');
    if (!node || signature(snapshot(node)) !== signature(cart.items)) throw new Error('Cart changed during refresh');
    return node;
  }
  function enhance() { root()?.querySelectorAll('[data-step]').forEach(button => { button.hidden = false; }); }
  function lock(node) { busy = true; node.setAttribute('aria-busy', 'true'); node.querySelectorAll('button,input').forEach(control => { control.disabled = true; }); }
  function fail(node) {
    node.setAttribute('aria-busy', 'false');
    node.querySelector('[data-cart-status]').textContent = 'We couldn’t confirm this cart update. Refresh your cart before making another change or checking out.';
    const refresh = node.querySelector('[data-cart-refresh]'); refresh.hidden = false; refresh.focus();
    // Deliberately stay locked: an ambiguous response must not trigger a retry or native fallback.
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-step]');
    if (!button || busy) return;
    const form = button.closest('form'), input = form.querySelector('input[type=number]');
    const current = Number(input.value);
    if (!Number.isSafeInteger(current) || current < 0) { input.reportValidity(); return; }
    input.value = Math.max(0, current + Number(button.dataset.step));
    form.requestSubmit();
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-quantity-form],[data-remove-form],[data-checkout-form]')) return;
    event.preventDefault();
    if (busy) return;
    const node = root(), url = node.dataset.cartUrl, checkout = form.matches('[data-checkout-form]');
    const quantity = form.matches('[data-remove-form]') ? 0 : Number(form.querySelector('input[type=number]')?.value);
    if (!checkout && (!Number.isSafeInteger(quantity) || quantity < 0)) { form.reportValidity(); return; }
    const variant = form.dataset.variant;
    lock(node);
    try {
      const before = await readCart(url);
      if (signature(before.items) !== signature(snapshot(node))) throw new Error('Stale cart');
      if (checkout) {
        const fresh = await serverRoot(url, before);
        if (fresh.dataset.eligible !== 'true') throw new Error('Checkout no longer eligible');
        node.replaceWith(fresh);
        const native = fresh.querySelector('[data-checkout-form]');
        const field = document.createElement('input'); field.type = 'hidden'; field.name = 'checkout'; field.value = 'checkout'; native.append(field);
        HTMLFormElement.prototype.submit.call(native);
        return;
      }
      const matches = item => String(item.variant_id) === variant && plain(item);
      const lines = before.items.filter(matches);
      if (!lines.length) throw new Error('Item no longer available');
      const updates = Object.fromEntries(lines.map((item,index) => [item.key,index === 0 ? quantity : 0]));
      const response = await fetch(url + '/update.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify({updates})});
      if (!response.ok) throw new Error('Cart update failed');
      const after = await readCart(url);
      if (after.items.filter(matches).reduce((total,item) => total + item.quantity,0) !== quantity || signature(before.items.filter(item => !matches(item))) !== signature(after.items.filter(item => !matches(item)))) throw new Error('Cart preservation check failed');
      const fresh = await serverRoot(url, after);
      node.replaceWith(fresh); busy = false; enhance();
      fresh.querySelector('[data-cart-status]').textContent = quantity === 0 ? 'Item removed.' : 'Quantity updated.';
    } catch (error) { fail(root()); }
  });
  window.addEventListener('pageshow', event => { if (event.persisted) { lock(root()); fail(root()); } });
  enhance();
})();
